import { ApolloError } from '@apollo/client';
import { ErrorResponse } from '@apollo/client/link/error';
import ErrorCode from 'v2/core/errors/codes';

const isApolloError = (error: any): error is ApolloError => {
  return error?.graphQLErrors !== undefined;
};

export const getApolloErrorCodes = (
  error: Error | ErrorResponse | undefined,
): ErrorCode[] | undefined => {
  if (error && isApolloError(error)) {
    return error.graphQLErrors.map(
      (graphQlError) => graphQlError?.extensions?.['errCode'],
    );
  }
};
